import { render, staticRenderFns } from "./info-list.vue?vue&type=template&id=28b43aca&scoped=true&"
import script from "./info-list.vue?vue&type=script&lang=js&"
export * from "./info-list.vue?vue&type=script&lang=js&"
import style0 from "./info-list.vue?vue&type=style&index=0&id=28b43aca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b43aca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
